import React, { useState } from "react";
import "./AddOrganization.css";
import { Box, Button, Text, Layer, FormField, TextInput, Form } from "grommet";
import { Mixpanel } from "../../../../../../util/Helper";
import { useStore } from "../../../../../../Hooks/useStore";
import closeAddOrganizationbar from "../../../../../../assets/close_small.svg";
import createOrganizationService from "../Users/CreateOrganization/create-organization.service";
import { FormTrash } from "grommet-icons";

function AddOrganization() {
  const { rootStore } = useStore();
  const [user, setUser] = useState({
    phoneNumbers: [""], // Initial phone number field
    emails: [""], // Initial email field
  });

  // Function to handle adding phone numbers
  const addPhoneNumber = () => {
    setUser((prev) => ({ ...prev, phoneNumbers: [...prev.phoneNumbers, ""] }));
  };

  // Function to handle adding email addresses
  const addEmail = () => {
    setUser((prev) => ({ ...prev, emails: [...prev.emails, ""] }));
  };

  // Function to handle deleting a phone number
  const deletePhoneNumber = (index) => {
    const updatedPhoneNumbers = user.phoneNumbers.filter((_, i) => i !== index);
    setUser((prev) => ({ ...prev, phoneNumbers: updatedPhoneNumbers }));
  };

  // Function to handle deleting an email
  const deleteEmail = (index) => {
    const updatedEmails = user.emails.filter((_, i) => i !== index);
    setUser((prev) => ({ ...prev, emails: updatedEmails }));
  };

  const onFormSubmit = ({ value }) => {
    Mixpanel.track("web_add_organization_submit_click", {
      name: user?.username,
    });
    const { name, address } = value;

    // Ensure emails and phone numbers are arrays, in case they are empty.
    const { phoneNumbers, emails } = user;

    // Validate email
    let a = 0;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    for (let email of emails) {
      if (!emailRegex.test(email) && a == 0) {
        a++;
        rootStore.notificationToastStore.showNotification('Please enter valid email.', true);
        return;
      }
    }

    // Validate organization name
    if (!name) {
      rootStore.errorHandlingStore.displayError("Invalid input, Please enter organization name.");
    } else {
      // Call API with multiple phone numbers and emails
      createOrganizationService
        .addOrganization(name, address, phoneNumbers, emails)
        .then(() => {
          rootStore.notificationToastStore.showNotification(
            "Successfully Created Organization",
            false,
            3000
          );
          rootStore.organizationStore.handleupdate();
          rootStore.organizationStore.handleAddOrganizationbar(false); // Close the modal
        })
        .catch((e) => {
          rootStore.notificationToastStore.showNotification(
            "Failed to create organization!",
            true,
            3000
          );
        });
    }
  };

  return (
    <>
      <Layer
        className="add-organization-container"
        full="vertical"
        position="right"
        style={{
          width: "500px",
          height: "100%",
          flexShrink: "0",
          borderRadius: "12px 0px 0px 12px",
          background: "#FFF",
        }}
        onClickOutside={() => {
          rootStore.organizationStore.handleAddOrganizationbar(false);
        }}
        onEsc={() => {
          rootStore.organizationStore.handleAddOrganizationbar(false);
        }}
      >
        <Box className="add-organization-modal">
          <Text className="add-organization-modal-test">Add Organization</Text>
          <Button
            className="close-btn"
            onClick={() => {
              rootStore.organizationStore.handleAddOrganizationbar(false);
            }}
          >
            <img
              src={closeAddOrganizationbar}
              style={{ width: 20, height: 20 }}
              alt="Close"
            />
            Close
          </Button>
        </Box>
        <Box className="add-organization-middle-modal">
          <Form validate="change" onSubmit={onFormSubmit}>
            <FormField
              style={{ borderBottom: "none" }}
              className="add-organization-form-F1"
              htmlFor="legalEntryName-id"
              name="name"
              validate={[
                {
                  regexp: /^[A-Za-z0-9 ]+$/,
                  message: "Legal Entry Name can only contain letters, numbers, and spaces.",
                },
              ]}
              >
              <label className="add-organization-modal-form-L1">
                Legal Entry Name
              </label>
              <TextInput
                className="add-organization-modal-form-I1"
                id="legalEntryName-id"
                name="name"
                maxLength={100}
                placeholder="Enter Here"
                onChange={(event) => {
                  setUser((prev) => ({ ...prev, name: event.target.value }));
                }}
              />
            </FormField>
            <FormField className="add-organization-form-F1">
              <label className="add-organization-modal-form-L1">Address</label>
              <TextInput
                className="add-organization-modal-form-I2"
                id="address-id"
                name="address"
                maxLength={100}
                placeholder="Enter Here"
                onChange={(event) => {
                  setUser((prev) => ({ ...prev, address: event.target.value }));
                }}
              />
            </FormField>

            {/* Phone Numbers Fields */}
            <FormField
              style={{ borderBottom: "none !important" }}
              className="add-organization-form-F1"
            >
              <label className="add-organization-modal-form-L1">Phone Number</label>
              {user.phoneNumbers.map((phone, index) => (
                <div key={index} style={{ position: "relative", marginTop: index === 0 ? 0 : 10 }}>
                  <TextInput
                    className="add-organization-modal-form-I3"
                    id={`phoneNumber-id-${index}`}
                    name="phoneNumber"
                    placeholder="Enter Here"
                    type="text"
                    pattern="\d*"
                    inputMode="numeric"
                    style={{ paddingRight: "40px" }}
                    value={phone}
                    onChange={(event) => {
                      const { value } = event.target;
                      const numericValue = value.replace(/\D/g, "");
                      setUser((prev) => {
                        const updatedPhones = [...prev.phoneNumbers];
                        updatedPhones[index] = numericValue;
                        return { ...prev, phoneNumbers: updatedPhones };
                      });
                    }}
                  />
                  {index !== 0 && (
                    <FormTrash
                      color="red"
                      className="delect-row"
                      onClick={() => deletePhoneNumber(index)}
                      style={{ position: "absolute", right: "10px", top: "25px", cursor: "pointer" }}
                    />
                  )}
                </div>
              ))}
              <div className="add-icon-container">
                {user.phoneNumbers.length < 10 ? (
                  <p className="add-row-btn" onClick={addPhoneNumber}>+</p>
                ) : (
                  <p className="add-row-btn-disabled" style={{ color: "gray", cursor: "not-allowed" }}>
                    Max Reached
                  </p>
                )}
              </div>
            </FormField>


            {/* Email Fields */}
            <FormField
              className="add-organization-form-F1"
              name="email"
              htmlFor="emailinput-id"
              validate={[
                {
                  regexp: /^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
                  message: "Invalid email format.",
                },
              ]}
            >
              <label className="add-organization-modal-form-L1">Email</label>
              {user.emails.map((email, index) => (
                <div key={index} style={{ position: "relative", marginTop: index === 0 ? 0 : 10 }}>
                  <TextInput
                    className="add-organization-modal-form-I3"
                    id={`email-id-${index}`}
                    name="email"
                    placeholder="Enter here"
                    type="email"
                    value={email}
                    maxLength={50}
                    onChange={(event) => {
                      const { value } = event.target;
                      setUser((prev) => {
                        const updatedEmails = [...prev.emails];
                        updatedEmails[index] = value;
                        return { ...prev, emails: updatedEmails };
                      });
                    }}
                  />
                  {index !== 0 && (
                    <FormTrash
                      color="red"
                      className="delect-row"
                      onClick={() => deleteEmail(index)}
                      style={{ position: "absolute", right: "10px", top: "25px", cursor: "pointer" }}
                    />
                  )}
                </div>
              ))}
              <div className="add-icon-container">
                {user.emails.length < 10 ? (
                  <p className="add-row-btn" onClick={addEmail}>+</p>
                ) : (
                  <p className="add-row-btn-disabled" style={{ color: "gray", cursor: "not-allowed" }}>
                    Max Reached
                  </p>
                )}
              </div>
              {/* <div className="add-icon-container">
                <p className="add-row-btn" onClick={addEmail}>+</p>
              </div> */}
            </FormField>

            <Box
              style={{ gap: "10px" }}
              className="add-organization-footer"
              pad="small"
              justify="end"
              direction="row"
              align="center"
            >
              <Button
                type="reset"
                className="add-organization-footer-btn1"
                onClick={() => {
                  Mixpanel.track("web_add_organization_reset_click", {
                    name: user?.username,
                  });
                }}
                label="Reset"
              />
              <Button
                type="submit"
                primary
                className="add-organization-footer-btn2"
                label="Add"
              />
            </Box>
          </Form>
        </Box>
      </Layer>
    </>
  );
}

export default AddOrganization;
